<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconLink_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M5.968 9.8c-1.189 0-2.063.851-2.063 1.8v1.8c0 .949.874 1.8 2.063 1.8H9.99c.526 0 .953.403.953.9s-.427.9-.953.9H5.97C3.825 17 2 15.434 2 13.4v-1.8C2 9.567 3.826 8 5.968 8H9.99c.526 0 .953.403.953.9s-.427.9-.953.9H5.97Zm7.09-.9c0-.497.427-.9.953-.9h4.02C20.175 8 22 9.567 22 11.6v1.8c0 2.034-1.826 3.6-3.968 3.6H14.01c-.526 0-.953-.403-.953-.9s.427-.9.953-.9h4.02c1.19 0 2.064-.851 2.064-1.8v-1.8c0-.949-.874-1.8-2.063-1.8H14.01c-.526 0-.953-.403-.953-.9Zm-5.026 3.6c0-.497.426-.9.952-.9h6.032c.526 0 .952.403.952.9s-.426.9-.952.9H8.984c-.526 0-.952-.403-.952-.9Z"
        clip-rule="evenodd"
    />
</svg>
